export default __webpack_public_path__ + "static/les-48b0881465b5363562ffd3a39a8beb72.jpg";